import { apiClient } from './client';

export const sideBarConfigApi = apiClient.injectEndpoints({
    endpoints: (builder: any) => ({
        getSideBarConfig: builder.query({
            query: (product: string) => ({
                url: '/api/config/sidenav',
                method: 'GET',
                params: { product: product },
            }),
        }),
    }),
});
export const { useGetSideBarConfigQuery } = sideBarConfigApi;
